import React from "react"; //
import {
  //
  bearlog,
  BearDiv,
  BearList,
  BearBorder,
} from "@sillyscribe95/bear-ui-web";
import Popover from "react-awesome-popover";

export function BearPopover({ children, content, ...okas }) {
  return (
    <Popover {...okas}>
      {children}
      {content}
    </Popover>
  );
}

export function BearListPopover({
  selected,
  itemConfig,
  renderItem,
  ...cxadsfa
}) {
  let oasdwe = {
    renderItem: asdfar,
    ...cxadsfa,
  };

  function asdfar(adsf) {
    return BearDiv({
      padding: "20px",
      obj: renderItem(adsf),
      ...itemConfig,
    });
  }

  let okas = {
    placement: "bottom-center",
    content: BearList(oasdwe),
  };

  return (
    <BearPopover {...okas}>
      {/*  */}
      {/* {BearList(oasdwe)} */}
      {asdfar(selected)}
    </BearPopover>
  );
}

export function PopList(aaa) {
  const { style, itemStyle } = aaa;

  const okasde = {
    style: {
      overflow: "scroll",
      height: "240px",
      ...style,
    },
  };

  const nidqws = {
    center: true,
    style: {
      //
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "28px",
      textAlign: "center",
      minWidth: "50px",
      // padding: "20px",
      height: "40px",
      // height: "40px",
      //   pad: "20px",
      color: "white",
      // ...BearBorder("white", "5px"),
      ...itemStyle,
    },
    className: "buttonHover",
  };

  return BearListPopover({
    ...aaa,
    ...okasde,
    itemConfig: nidqws,
  });
}
